<template>
    <div class="gs-checkout-share-panel">
        <div class="w-full">
            <label class="text-base font-bold text-grey-800 mb-2">{{
                $t('frontend_embed_link')
            }}</label>
            <text-area :value="checkout_embed" class="w-full mt-2" :readonly="true"
                :placeholder="$t('frontend_pgroovesell_checkout_link')" :select-all="true" />
        </div>
        <div class="gs-checkout-share-panel__actions">
            <gs-button v-clipboard:copy="checkout_embed" v-clipboard:success="onCopy" v-clipboard:error="onError" variant="primary">
                {{ $t('frontend_copy') }}
            </gs-button>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        checkout_embed: {
            required: true
        },
        onCopy: {
            type: Function,
            required: true
        },
        onError: {
            type: Function,
            required: true
        }
    }
}
</script>

<style scoped>
.gs-checkout-share-panel__actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 18px;
}
</style>
